import React, {useEffect, useState} from 'react'
import {useAuthState } from 'react-firebase-hooks/auth';
import { Link, useNavigate } from 'react-router-dom';
import { auth, registerWithEmailAndPassword, 
        signInWithGoogle} from './firebase';
import './Register.css';
import * as RiIcons from 'react-icons/ri'

function Register() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [name, setName] = useState("");
    const [user, loading, error] = useAuthState(auth);
    const navigate = useNavigate();

    const register = () => {
        if (!name) alert("Por favor ingrese su nombre!");
        console.log('Datos ingresando correctamente enviando al sistema');
        registerWithEmailAndPassword(name, email, password);
    };

    useEffect(() => {
        if (loading) return;
        if (user) navigate("/home");
    }, [user, loading]);

  return (
    <div className="register">
      <div>
        <img className='logo__carbonbox' src='/logo-carbonbox-full.svg'></img>    
        <label className='texto__informativo' style={{left:'50px',top:'-130px',position:'relative'}}>Imagen de perfil</label>
      </div>
      <div className='contenedor__imagen__perfil'>
        
        <img className='imagen__perfil'  src='/logo-carbonbox-full.svg'></img>    
        <div style={{display:'flex'}}>
          <button className='boton__imagen'><img src='/button-add-2.svg'></img></button>
        </div>
      </div>
    
      <div className="register__container">
        <label className='texto__informativo'>Usuario</label>
        <input
          type="text"
          className="register__textBox"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Nombre completo"
        />
        <label className='texto__informativo'>Correo</label>
        <input
          type="text"
          className="register__textBox"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Correo electrónico"
        />
        <label className='texto__informativo'>Contraseña</label>
        <input
          type="password"
          className="register__textBox"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Constraseña"
        />

        <div>
          ¿Ya se está registrado? <Link to="/"> Inicie sesión. </Link>
        </div>
      </div>
      <button className="register__btn font__family" onClick={register}>
        CONTINÚA <RiIcons.RiArrowRightFill/>
      </button>
    </div>
  )
}

export default Register;
